import { render, staticRenderFns } from "./FurnitureSubCategory.vue?vue&type=template&id=f2c1b3ce"
import script from "./FurnitureSubCategory.vue?vue&type=script&lang=js"
export * from "./FurnitureSubCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports